import React from 'react';
// import { Button } from 'semantic-ui-react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import {
  resetUploadProgress,
  hideUploadProgress,
  //cancelUpload,
} from '../../common/UI/state/actions';
//import { source } from '../../api/MPWApi';

const UploadComplete = dispatch => {
  setTimeout(() => dispatch(hideUploadProgress()), 1000);
  setTimeout(() => dispatch(resetUploadProgress()), 3000);
};

const UploadProgressComponent = ({
  dispatch,
  uploadProgressDisplay,
  uploadProgressTotal,
  uploadProgressCurrent,
  uploadProgressCanceled,
}) => {
  const progress = +uploadProgressCurrent
    ? parseInt((uploadProgressCurrent / uploadProgressTotal) * 100, 10)
    : 0;

  const complete = progress === 100;

  const wrapperClassnames = classNames('upload-progress--wrapper', {
    active: uploadProgressDisplay,
    complete: complete,
    canceled: uploadProgressCanceled,
  });

  if (complete) setTimeout(UploadComplete(dispatch));

  return (
    <div className={wrapperClassnames}>
      <div className="upload-progress--content">
        <h4>
          {uploadProgressCanceled
            ? 'UPLOAD CANCELED!'
            : complete
              ? 'COMPLETE!'
              : 'UPLOAD PROGRESS:'}
        </h4>
        {/* <Button
          className="upload-progress--cancel"
          size="mini"
          onClick={event => {
            event.preventDefault();
            source.cancel('Operation canceled by the user.');
            dispatch(cancelUpload());
            setTimeout(() => {
              UploadComplete(dispatch);
            }, 1500);
          }}
        >
          CANCEL
        </Button> */}
        <div className="upload-progress--bar">
          <span className="upload-progress--status">{progress}%</span>
          <span
            className="upload-progress--progress"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state.GlobalUIState,
  };
};

const UploadProgress = connect(mapStateToProps)(UploadProgressComponent);

export { UploadProgress };



// WEBPACK FOOTER //
// ./src/containers/app/UploadProgress.js